import React from 'react';
import ContactForm from './subcomponents/ContactForm';

const Contact = () => {
    return(
        <div className="container-fluid">
            <ContactForm />
        </div>
    );
}

export default Contact;